import { updateObject } from '../utility';

const initialState = {
    data: null,
}

const setVipLevelData = (state, action) => {
    return updateObject(state, {data: action.vipLevelData});
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case 'SET_VIP_LEVEL_DATA': return setVipLevelData(state, action);
        default: return state;
    }
};

export default reducer;